<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">

        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="商品类型" prop="type">
            <el-select
              v-model.number="queryParams.type"
              placeholder="请选择商品类型"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option v-for="(item, index) in shopType" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>礼品列表</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:shopCfg:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:shopCfg:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>
          </el-row>
        </div>

        <el-row :gutter="10" class="mb8" style="margin-top: 10px;">
          <el-col :span="1.5">
            <el-button v-permisaction="['config:shopCfg:add']" icon="el-icon-upload2" size="mini" type="primary" @click="addShop(0)">新增</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="gid"
            label="商品ID"
          />

          <el-table-column
            prop="desc"
            label="备注"
          />

          <el-table-column
            prop="min_level"
            label="最小等级"
          />

          <el-table-column
            prop="max_level"
            label="最大等级"
          />

          <el-table-column
            prop="life_time"
            label="有效时间(小时)"
          />

          <el-table-column
            prop="discount"
            label="折扣"
          />

          <el-table-column
            prop="prize_json"
            label="内含商品"
          >
            <template v-slot:default="scope">
              {{ productFormatter(scope.row) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="商品状态"
          />

          <el-table-column
            label="操作"
          >
            <template v-slot:default="scope">
              <el-button v-permisaction="['config:shopCfg:edit']" type="text" size="small" @click="addShop(scope.row.type, scope.row.id)">编辑</el-button>
              <el-button v-permisaction="['config:shopCfg:del']" type="text" size="small" @click="del(scope.row.type, scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables(item.value)"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCateList } from '@/api/config/lucky-draw'
import { getRewardType } from '@/api/config/slot'

import {
  deleteShopCfg,
  exportShopCfg,
  exportShopPrizeCfg,
  getShopCfgList, getShopType,
  importShopCfg,
  importShopPrizeCfg,
  updateShopCfg
} from '@/api/config/shop-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'Shop',
  data() {
    return {
      activeName: '101',
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: ''
      },
      statusType: [{
        value: 1,
        label: '开启'
      }, {
        value: 0,
        label: '关闭'
      }],
      shopType: [],
      options: [],
      visibleArr: [{ visible: false }],
      tableData: [
        {
          'id': 0,
          'gid': 0,
          'g_type': 0,
          'desc': '',
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': 0,
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'ss_group': ''
        }
      ],
      formData: [
        {
          'id': 0,
          'gid': 0,
          'g_type': 0,
          'desc': '',
          'min_level': 0,
          'max_level': 0,
          'life_time': 0,
          'price': 0,
          'sku': 0,
          'discount': 0,
          'skin_dir': '',
          'status': 0,
          'ss_group': '',
          'prize_json': [
            {
              type: 1,
              id: 201,
              num: 1
            }
          ]
        }
      ],
      cateType: [],
      selectType: [
        {
          'id': 1,
          'title': '金币'
        },
        {
          'id': 2,
          'title': '体力'
        },
        {
          'id': 3,
          'title': '卡片'
        },
        {
          'id': 4,
          'title': '星星'
        }
      ]
    }
  },
  created() {
    this.getRewardList()
    this.getTables()
    this.getCateType()
    this.getShopTypes()
  },
  methods: {
    handleQuery() {
      this.getTables()
    },
    resetQuery() {
      this.dateRange = []
      this.resetForm('queryForm')
      this.handleQuery()
    },
    addShop(type, id = 0) {
      this.$router.push({ name: 'ShopEdit', query: { id: id, type: type }})
    },
    getShopTypes() {
      getShopType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.shopType.push({ label: val, value: parseInt(i) })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    onSubmit() {
      const data = []
      for (const k in this.formData) {
        const item = this.formData[k]
        if (item.min_level > item.max_level) {
          this.msgError('最低等级不能大于最高等级')
          return
        }

        if (item.price < 0) {
          this.msgError('金额不能小于0')
          return
        }

        if (item.discount < 0) {
          this.msgError('优惠金额不能小于0')
          return
        }
        item.price = parseFloat(item.price)
        item.discount = parseFloat(item.discount)
        data.push(item)
      }
      const postdata = JSON.stringify(data)
      updateShopCfg({ data: postdata }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(type) {
      getShopCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardList() {
      getRewardType().then(res => {
        if (res.code === 200) {
          // this.options[index][zIndex] = res.data
          this.options = res.data
        } else {
          console.log(res.msg)
        }
      })
    },
    removeReward(index, zIndex) {
      this.formData[index].prize_json = this.formData[index].prize_json.filter((item, i) => {
        return i !== zIndex
      })
    },
    getCateType() {
      getCateList().then(res => {
        if (res.code === 200) {
          this.cateType = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(key, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteShopCfg({ id: id }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables(key)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      }
    },
    exportData(type, name) {
      exportShopCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportPrizeData() {
      exportShopPrizeCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importShopCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        console.log(this.loading)
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importPrizeUploadSuccess(response) {
      importShopPrizeCfg({ data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    typeFormatter(row) {
      let name = ''
      this.shopType.forEach((item) => {
        if (row.type === item.g_type) {
          name = item.label
        }
      })
      return name + '(Lv' + row.min_level + ')'
    }, handleClick(tab, event) {
      console.log(tab.name)
      this.getTables(tab.name)
    },
    productFormatter(row) {
      let str = ''
      if (row.prize_json) {
        const options = this.options
        console.log('options ', options)
        row.prize_json.forEach(res => {
          console.log('propsId', res.propsId)
          if (options[res.propsId]) {
            str += options[res.propsId] + '数量:' + res.num + ' '
          }
        })
        return str
      }

      return str
    }
  }
}
</script>

<style scoped>
</style>
